/*
 * @Author: jerryfwang
 * @Date: 2018-08-21 19:47:13
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2019-09-02 15:58:18
 */
// @ flow

import React from 'react';
import get from 'lodash/get';
import castArray from 'lodash/castArray';
import './bookcard.scss';
export default class BookCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddBook: false,
    };
  }
  componentDidMount() {
    /* eslint-disable react/no-did-mount-set-state */
    const version = get(window, 'browser.env.version') || 0;
    this.setState({
      isAddBook: version >= 85,
    });
    const tag = 'bookrack';
    window.PAGENAME = tag;
    window.OTHERFTSCRIPT = window.OTHERFTSCRIPT || '';
    let otherFt = window.OTHERFTSCRIPT;
    otherFt = otherFt.split(',');
    if (otherFt.indexOf(tag) < 0) {
      otherFt.push(tag);
      window.OTHERFTSCRIPT = castArray(otherFt).filter(Boolean).join(',');
    }
  }
  render() {
    const { authorName, category, coverImage, id, title } = this.props || {};
    if (!id || !title) {
      return null;
    }
    const star = [];
    for (let index = 0; index < 5; index += 1) {
      star.push(
        <span key={index}>
          <span></span>
        </span>,
      );
    }
    return (
      <div className="mod-booksheet--item" key={id}>
        <div className="mod-book--wrap" data-on={`?m=newsGoBook&bookid=${id}&reportKey=newsGoBook&outerCh=004514`}>
          <div className="mod-book--item">
            <div className="cb-flexbox__item is-flex-none">
              <div>
                <img src={coverImage} alt={title} className="mod-img--wrap" data-on="?m=imageError" />
              </div>
            </div>
            <div className="cb-flexbox__item">
              <div className="mod-book--title">{title}</div>
              <div className="mod-book--rate" data-bookid={id}>
                <ul data-on={`?m=voteScore&resourceid=${id}`}>
                  <span className="mod-5star">{star}</span>
                  <span></span>
                </ul>
              </div>
              <div className="mod-book--sm mod-book--auther">
                <i className="ico-reader"></i>
                <span>{authorName}</span>/<span>{category}</span>
              </div>
            </div>
            {this.state.isAddBook ? (
              <div className="cb-flexbox__item flex-end">
                <span className="flex-end-btn" data-on={`?m=newsAddBook&bookid=${id}&reportKey=newsAddBook`}>
                  阅读
                </span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
